import { GameServices } from "game/GameServices";
import { View } from "@westpierstudio/luma/mvc";
import { Signal } from "type-signals";
import { Tween } from "@westpierstudio/luma/createjs";
import { Sprite, Rectangle } from "pixi.js";

class VSScreenButtonSignals {
    onClick = new Signal();
}

export class VSScreenButton extends View {
    private spec: Record<string, any>;
    private sprites! : {normal: Sprite, glow: Sprite};
    signals = new VSScreenButtonSignals();

    constructor(protected override readonly services: GameServices, spec: Record<string, any>, label: string, glowColour: number) {
        super(services);

        const {factory, resources} = this.services;

        factory.applySpec(this, spec);

        this.spec = resources.getSpec(`vsscreen`);

        let normalSprite;
        if (label === `Dragon Reels`)
        {
            normalSprite = factory.createSprite(this.spec.dragonButtonNormal, this);
        }
        else
        {
            normalSprite = factory.createSprite(this.spec.pandaButtonNormal, this);
        }

        let glowSprite;
        if (label === `Dragon Reels`)
        {
            glowSprite = factory.createSprite(this.spec.dragonButtonGlow, this);
        }
        else
        {
            glowSprite = factory.createSprite(this.spec.pandaButtonGlow, this);
        }

        this.sprites = {
            normal: normalSprite,
            glow: glowSprite
        };

        this.addChild(this.sprites.glow);
        this.addChild(this.sprites.normal);

        // setup vs button interaction behaviour
        let hitArea;
        if (label === `Dragon Reels`) {
            hitArea = this.spec.hitAreaDragons;
        } else {
            hitArea = this.spec.hitAreaPandas;
        }

        const {x, y, width, height} = hitArea;
        this.hitArea = new Rectangle(x, y, width, height);

        this.addListener(`click`, this.onClick, this)
        .addListener(`tap`, this.onClick, this)
        .addListener(`mouseover`, this.onOver, this)
        .addListener(`pointerover`, this.onOver, this)
        .addListener(`mouseout`, this.onOut, this)
        .addListener(`pointerout`, this.onOut, this)
        .addListener(`mousedown`, this.onOut, this)
        .addListener(`pointerdown`, this.onOut, this);
    }

    setInteractive(): void {
        this.interactive = this.buttonMode = true;
    }

    setGlowOn(): void {
        this.sprites.glow.visible = true;
    }

    setGlowOff(): void {
        this.sprites.glow.visible = false;
    }

    private onOver(): void {
        Tween.get(this.sprites.normal.scale).to({x:this.spec.buttonHover.scale.x, y:this.spec.buttonHover.scale.y}, this.spec.buttonHover.time);
        Tween.get(this.sprites.glow.scale).to({x:this.spec.buttonHover.scale.x, y:this.spec.buttonHover.scale.y}, this.spec.buttonHover.time);
    }

    override reset(): void {
        this.interactive = this.buttonMode = false;
    }

    private onClick(): void {
        this.interactive = false;
        this.signals.onClick.dispatch();

        Tween.get(this.sprites.normal.scale).to({x:this.spec.buttonClick.scale.x, y:this.spec.buttonClick.scale.y}, this.spec.buttonClick.time);
        Tween.get(this.sprites.glow.scale).to({x:this.spec.buttonClick.scale.x, y:this.spec.buttonClick.scale.y}, this.spec.buttonClick.time);
    }

    private onOut(): void {
        Tween.get(this.sprites.normal.scale).to({x:this.spec.buttonClick.scale.x, y:this.spec.buttonClick.scale.y}, this.spec.buttonHover.time);
        Tween.get(this.sprites.glow.scale).to({x:this.spec.buttonClick.scale.x, y:this.spec.buttonClick.scale.y}, this.spec.buttonHover.time);
    }
}